import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './processCatalog.state';
import { processCatalogReducers } from './actions';

const processCatalog = createSlice({
  name: 'processCatalog',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    processCatalogReducers(builder);
  },
});

export const processCatalogReducer = processCatalog.reducer;
